import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-tc',
  templateUrl: './tc.component.html',
  styleUrls: ['./tc.component.scss']
})
export class TcComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
